<div class="hbox bg-white font-noto"
     (click)="getStarted()">
  <div class="flex-box"
       [ngClass]="language">
    <div class="tw-flex tw-flex-col tw-flex-nowrap tw-justify-end tw-h-full tw-overflow-hidden">
      <div class="tw-relative tw-flex tw-items-start tw-justify-center tw-flex-1 tw-overflow-visible">
        <div
             class="tw-relative tw-overflow-hidden tw-w-full tw-h-[calc(100%+56px)] tw-bg-[url('https://cdn.cureskin.com/app/img/intro.png')] tw-bg-cover tw-bg-[center_-24px] tw-bg-no-repeat">
        </div>
        <div class="tw-absolute tw-top-16 tw-left-1/2 -tw-translate-x-1/2 tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-3">
          <img class="tw-w-28" src="https://cdn.cureskin.com/app/img/welcome_to_cure.png" alt="">
          <div class="tw-w-[80%] tw-mx-auto tw-h-[1px] tw-bg-black tw-opacity-20 tw-mb-1"></div>
          <img class="tw-w-40" src="https://cdn.cureskin.com/app/img/cure_logo.gif" alt="Cure Logo">
        </div>
      </div>
      <div class="tw-relative tw-my-0 tw-bg-white tw-z-10 tw-rounded-5 tw-pt-7">
        <footer class="tw-h-[160px] tw-px-6 tw-relative tw-z-100">
          <button csButton
                  id="skip"
                  type="button"
                  class="tw-w-full tw-mx-auto"
                  (click)="getStarted()"><span i18n="@@getStarted">Get Started</span>
          </button>
          <div
               class="tw-flex swiper-container tw-mt-2 tw-font-normal tw-text-teal-600 tw-font-lexend tw-text-300 tw-py-1">
            <swiper class="swiper-wrapper"
                    [config]="carouselConfig">
              <div class="tw-flex tw-items-center tw-justify-center tw-flex-col tw-flex-nowrap tw-h-full tw-overflow-hidden"
                   *swiperSlide>
                <p i18n="@@ticker1"> Trusted by 17 lakh+ Indians </p>
              </div>
              <div class="tw-flex tw-items-center tw-justify-center tw-flex-col tw-flex-nowrap tw-h-full tw-overflow-hidden"
                   *swiperSlide>
                <p i18n="@@ticker2"> Team of 40+ best doctors </p>
              </div>
              <div class="tw-flex tw-items-center tw-justify-center tw-flex-col tw-flex-nowrap tw-h-full tw-overflow-hidden"
                   *swiperSlide>
                <p i18n="@@ticker3"> 30 million+ faces got free analysis </p>
              </div>
            </swiper>
          </div>
        </footer>
      </div>
    </div>
  </div>
</div>
